module.exports = __webpack_public_path__ + "static/img/qiyebanner.54c3103.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qiyebanner.png
// module id = lXra
// module chunks = 0